export default (stroke) => `
    <svg width="18" height="31" viewBox="0 0 18 31" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.5 30L2 15.5L16.5 1" stroke="${stroke}" stroke-width="1.5"/>
    </svg>
`;
